module.exports = __webpack_public_path__ + "static/process_exporting5_3-65f4c27ddd8c610be680a005d794004a.png";